import { orchestrator } from 'satcheljs';
import { default as completeGetStartedTask } from '../actions/completeGetStartedTask';
import { GetStartedTaskId } from '../enums/GetStartedTaskId';
import { openPremiumUpsell } from '../actions/openPremiumUpsell';

orchestrator(openPremiumUpsell, () => {
    window.open(
        'https://go.microsoft.com/fwlink/?linkid=867712&WT.mc_id=PROD_OL-Web_InApp_GetStarted_Upgrade&ep'
    );
    completeGetStartedTask(GetStartedTaskId.PremiumUpsell);
});
